import React from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";
import styles from "./KeepReading.css";

export default function KeepReading(props) {
  const { block, extras, isClient } = props;
  const { data } = block;
  const { wordCount, permalink } = extras || {};

  const keepReadingChildren = (
    <React.Fragment>
      <Icon
        name="chevron/down"
        description="Read more toggle"
        className={styles.icon}
      />
      <div className={styles.showLess}>Show less</div>
      <div className={styles.keepReading}>
        {data.buttonText}
        {data.showWordCount &&
          wordCount && (
            <span className={styles.wordCount}>{wordCount} Words</span>
          )}
      </div>
      <div className={styles.hide}>{props.children}</div>
    </React.Fragment>
  );

  return (
    <div className={styles.centeringWrapper}>
      {isClient ? (
        <button
          id={`keep-reading-${block.key}`}
          className={styles.root}
          aria-expanded={false}
        >
          {keepReadingChildren}
        </button>
      ) : (
        <a
          aria-label={data.buttonText}
          href={permalink}
          className={styles.root}
        >
          {keepReadingChildren}
        </a>
      )}
    </div>
  );
}

KeepReading.propTypes = {
  block: PropTypes.object.isRequired,
  extras: PropTypes.object,
  isClient: PropTypes.bool.isRequired,
};
